export const GET_COMPANY_PROFILE = {
  INITIATE: 'GET_COMPANY_PROFILE_INITIATE',
  SUCCESS: 'GET_COMPANY_PROFILE_SUCCESS',
  FAILED: 'GET_COMPANY_PROFILE_FAILED',
};

export const VERIFY_COMPANY = {
  INITIATE: 'VERIFY_COMPANY_INITIATE',
  SUCCESS: 'VERIFY_COMPANY_SUCCESS',
  FAILED: 'VERIFY_COMPANY_FAILED',
};

export const GET_HOME_PAGE = {
  INITIATE: 'GET_HOME_PAGE_INITIATE',
  SUCCESS: 'GET_HOME_PAGE_SUCCESS',
  FAILED: 'GET_HOME_PAGE_FAILED',
};

export const GET_UPCOMING_TOPUPS = {
  INITIATE: 'GET_UPCOMING_TOPUPS_INITIATE',
  SUCCESS: 'GET_UPCOMING_TOPUPS_SUCCESS',
  FAILED: 'GET_UPCOMING_TOPUPS_FAILED',
};

export const GET_PREVIOUS_TOPUPS = {
  INITIATE: 'GET_PREVIOUS_TOPUPS_INITIATE',
  SUCCESS: 'GET_PREVIOUS_TOPUPS_SUCCESS',
  FAILED: 'GET_PREVIOUS_TOPUPS_FAILED',
};

export const GET_CONSUMPTION_DETAILS = {
  INITIATE: 'GET_CONSUMPTION_DETAILS_INITIATE',
  SUCCESS: 'GET_CONSUMPTION_DETAILS_SUCCESS',
  FAILED: 'GET_CONSUMPTION_DETAILS_FAILED',
};

export const GET_EVENT_DETAILS = {
  INITIATE: 'GET_EVENT_DETAILS_INITIATE',
  SUCCESS: 'GET_EVENT_DETAILS_SUCCESS',
  FAILED: 'GET_EVENT_DETAILS_FAILED',
};

export const GET_COMPANY_INVOICES = {
  INITIATE: 'GET_COMPANY_INVOICES_INITIATE',
  SUCCESS: 'GET_COMPANY_INVOICES_SUCCESS',
  FAILED: 'GET_COMPANY_INVOICES_FAILED',
};

export const GET_INVOICE_DETAILS = {
  INITIATE: 'GET_INVOICE_DETAILS_INITIATE',
  SUCCESS: 'GET_INVOICE_DETAILS_SUCCESS',
  FAILED: 'GET_INVOICE_DETAILS_FAILED',
};

export const GET_PAYMENTS_FOR_INVOICE = {
  INITIATE: 'GET_PAYMENTS_FOR_INVOICE_INITIATE',
  SUCCESS: 'GET_PAYMENTS_FOR_INVOICE_SUCCESS',
  FAILED: 'GET_PAYMENTS_FOR_INVOICE_FAILED',
};

export const GET_COMPANY_MAPPED_OFFICES = {
  INITIATE: 'GET_COMPANY_MAPPED_OFFICES_INITIATE',
  SUCCESS: 'GET_COMPANY_MAPPED_OFFICES_SUCCESS',
  FAILED: 'GET_COMPANY_MAPPED_OFFICES_FAILED',
};

export const getEventDetailsInitiate = payload => ({
  type: GET_EVENT_DETAILS.INITIATE,
  payload,
});

export const getEventDetailsFailed = err => ({
  type: GET_EVENT_DETAILS.FAILED,
  err,
});

export const getEventDetailsSuccess = eventData => ({
  type: GET_EVENT_DETAILS.SUCCESS,
  eventData,
});

export const getUpcomingTopupsInitiate = payload => ({
  type: GET_UPCOMING_TOPUPS.INITIATE,
  payload,
});

export const getUpcomingTopupsFailed = err => ({
  type: GET_UPCOMING_TOPUPS.FAILED,
  err,
});

export const getUpcomingTopupsSuccess = upcomingTopupsData => ({
  type: GET_UPCOMING_TOPUPS.SUCCESS,
  upcomingTopupsData,
});

export const getPreviousTopupsInitiate = payload => ({
  type: GET_PREVIOUS_TOPUPS.INITIATE,
  payload,
});

export const getPreviousTopupsFailed = err => ({
  type: GET_PREVIOUS_TOPUPS.FAILED,
  err,
});

export const getPreviousTopupsSuccess = previousTopupsData => ({
  type: GET_PREVIOUS_TOPUPS.SUCCESS,
  previousTopupsData,
});

export const getConsumptionDetailsInitiate = payload => ({
  type: GET_CONSUMPTION_DETAILS.INITIATE,
  payload,
});

export const getConsumptionDetailsFailed = err => ({
  type: GET_CONSUMPTION_DETAILS.FAILED,
  err,
});

export const getConsumptionDetailsSuccess = ordersData => ({
  type: GET_CONSUMPTION_DETAILS.SUCCESS,
  ordersData,
});

export const SET_COMPANY_VERIFIED = 'SET_COMPANY_VERIFIED';

export const getCompanyDetailsInitiate = () => ({
  type: GET_COMPANY_PROFILE.INITIATE,
});

export const getCompanyDetailsFailed = err => ({
  type: GET_COMPANY_PROFILE.FAILED,
  err,
});

export const getCompanyDetailsSuccess = companyData => ({
  type: GET_COMPANY_PROFILE.SUCCESS,
  companyData,
});

export const getLandingPageInitiate = payload => ({
  type: GET_HOME_PAGE.INITIATE,
  payload,
});

export const getLandingPageSuccess = landingPageDetails => ({
  type: GET_HOME_PAGE.SUCCESS,
  landingPageDetails,
});

export const getLandingPageFailed = err => ({
  type: GET_HOME_PAGE.FAILED,
  err,
});

export const verifyCompanyInitiate = () => ({
  type: VERIFY_COMPANY.INITIATE,
});

export const verifyCompanyFailed = () => ({
  type: VERIFY_COMPANY.FAILED,
});

export const verifyCompanySuccess = () => ({
  type: VERIFY_COMPANY.SUCCESS,
});

export const setCompanyVerified = isVerified => ({
  type: SET_COMPANY_VERIFIED,
  isVerified,
});

export const getCompanyInvoicesInitiate = payload => ({
  type: GET_COMPANY_INVOICES.INITIATE,
  payload,
});

export const getCompanyInvoicesSuccess = invoiceData => ({
  type: GET_COMPANY_INVOICES.SUCCESS,
  invoiceData,
});

export const getCompanyInvoicesFailed = err => ({
  type: GET_COMPANY_INVOICES.FAILED,
  err,
});

export const getInvoicesDetailsInitiate = payload => ({
  type: GET_INVOICE_DETAILS.INITIATE,
  payload,
});

export const getInvoicesDetailsSuccess = invoiceDetails => ({
  type: GET_INVOICE_DETAILS.SUCCESS,
  invoiceDetails,
});

export const getInvoicesDetailsFailed = err => ({
  type: GET_INVOICE_DETAILS.FAILED,
  err,
});

export const getPaymentsForInvoiceInitiate = payload => ({
  type: GET_PAYMENTS_FOR_INVOICE.INITIATE,
  payload,
});

export const getPaymentsForInvoiceSuccess = invoicePayments => ({
  type: GET_PAYMENTS_FOR_INVOICE.SUCCESS,
  invoicePayments,
});

export const getPaymentsForInvoiceFailure = err => ({
  type: GET_PAYMENTS_FOR_INVOICE.FAILED,
  err,
});

export const getCompanyMappedOfficesInitiate = payload => ({
  type: GET_COMPANY_MAPPED_OFFICES.INITIATE,
  payload,
});

export const getCompanyMappedOfficesFailed = err => ({
  type: GET_COMPANY_MAPPED_OFFICES.FAILED,
  err,
});

export const getCompanyMappedOfficesSuccess = mappedOffices => ({
  type: GET_COMPANY_MAPPED_OFFICES.SUCCESS,
  mappedOffices,
});
